var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreenCheckCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 14.72V16.008C29.9983 19.027 29.0207 21.9646 27.2131 24.3826C25.4054 26.8006 22.8646 28.5695 19.9695 29.4255C17.0744 30.2815 13.9802 30.1787 11.1483 29.1324C8.31635 28.0862 5.89852 26.1525 4.25534 23.6199C2.61217 21.0873 1.83171 18.0913 2.03035 15.0788C2.22899 12.0664 3.39609 9.19887 5.35759 6.90391C7.31909 4.60896 9.9699 3.00955 12.9147 2.34422C15.8594 1.67889 18.9404 1.98329 21.698 3.21201",
    stroke: "#0CC74C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6L16.1538 18L12 13.8042",
    stroke: "#0CC74C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreenCheckCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/green-check-circle.1f650475a3d2f5933856edd9f647c04f.svg";